export default __webpack_public_path__ + "static/media/CloseIcon.7419f8aa.svg";